<template>
  <div>
    <div
      v-if="listen"
      class="container-fluid text-center py-3 mb-2"
      style="border: solid 1px silver; border-radius: 5px"
    >
      <b-img
        src="https://i.makeagif.com/media/8-13-2019/gzAYga.gif"
        fluid
        v-bind="imageprops"
      ></b-img>
    </div>
    <b-form-group label-for="idtextos">
      <b-list-group>
        <b-list-group-item v-for="(t, i) of textos" :key="i">
          <span v-copy class="float-left">
            {{ t.texto }}
          </span>
          <b-button
            variant="danger"
            class="btn-icon float-right"
            @click="removetexto(i)"
            ><b-icon-trash></b-icon-trash
          ></b-button>
        </b-list-group-item>
        <b-list-group-item v-if="vdisablemic && textos.length == 0"
          >&nbsp;</b-list-group-item
        >
      </b-list-group>
    </b-form-group>
    <b-form-group label-for="idmic" class="">
      <div class="text-center spaced">
        <b-button
          id="idmic"
          variant="success"
          :disabled="!vdisablemic"
          @click="rec"
        >
          <b-icon-mic v-if="vdisablemic"></b-icon-mic>
          <b-icon-mic-mute variant="danger" v-else></b-icon-mic-mute>
        </b-button>
        <b-button
          v-if="!vdisablemic"
          id="idstop"
          variant="danger"
          @click="stop"
        >
          <b-icon-stop></b-icon-stop>
        </b-button>
        <b-button
          id="idclear"
          variant="danger"
          :disabled="textos.length == 0"
          @click="clear"
        >
          <b-icon-eraser-fill></b-icon-eraser-fill>
        </b-button>
      </div>
    </b-form-group>

    comando:
    <pre>{{ comando }}</pre>
    textos:
    <pre>{{ textos }}</pre>
    counter: {{ counter }}
  </div>
</template>

<script>
import voice from "../services/voice2text";

export default {
  name: "Recognition",

  data() {
    return {
      imageprops: { blank: false, height: 150, class: "m1" },
      voice: voice,
      listen: false,
      counter: 0,
      texto: "",
      textos: [],
      comando: {
        acao: null,
        rota: null,
        params: [],
      },
    };
  },

  computed: {
    gifwave() {
      return require("../assets/gifs/bluelightwave.gif");
    },
    vdisablemic() {
      return !this.listen;
    },
  },

  methods: {
    rec() {
      this.texto = "";
      this.voice.start(
        this.onlisten,
        this.ondone,
        this.onerror,
        this.oncounter
      );
    },
    stop() {
      this.voice.stop();
      this.texto = "";
      this.listen = false;
    },
    clear() {
      this.textos = [];
      this.texto = "";
      this.listen = false;
      this.comando = {
        acao: null,
        rota: null,
        params: [],
      };
    },
    removetexto(index) {
      if (index > -1) {
        this.textos.splice(index, 1);
      }
    },

    /* EVENTS LISTEN */
    onlisten(listen) {
      // console.log("onlisten:", listen);
      this.listen = listen;
    },
    ondone(text) {
      // console.log("ondone: ", text);
      let id = this.textos.reduce((a, b) => a + b.id, 0);
      const add = { id: id++, texto: text };
      this.texto = text;
      this.textos.push(add);
      const comandos = this.texto.split(" ");
      if (comandos.length > 0) {
        this.comando.acao = comandos[0];
      }
      if (comandos.length > 1) {
        this.comando.rota = comandos[1];
      }
      if (comandos.length > 2) {
        this.comando.params = comandos.filter((c, i) => i >= 2);
      }
    },
    onerror(message) {
      console.log("error:", message);
    },
    oncounter(count) {
      this.counter = count;
      // console.log("count:", count);
    },
  },
};
</script>
